/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgImport = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M22 22H2V2h20zM4 20h16V5.4L12.4 13H17v2H9V7h2v4.6L18.6 4H4z" fill="currentcolor" />
  </Icon>
);
export { SvgImport as Import };
